import type * as React from 'react'

// NOTE (Phase 00 contract gap, still open): reference/ICON-NORMALISATION.md §(c) specifies a
// shared `SvgIconProps` from './types.ts'. That file has no owning task in any phase file, so
// this component must not create `./types.ts` unprompted — the prop type is inlined here rather
// than imported, matching every other icon component in this set.
type SvgIconProps = Omit<React.SVGProps<SVGSVGElement>, 'children'> & {
  /** Accessible name. Omit for a purely decorative icon (default: aria-hidden). */
  title?: string
}

// Single-size icon (icon / 16 / Trash, node 113:2844). Fixed intrinsic 16x16 — no `size` prop;
// this name was not among the 9 dual-size names measured under D-ICON-1. Three kept paths (two
// bin-line strokes-as-fills, one compound bin-body path), the raw export's inner `<g id="Vector">`
// wrapper carried no transform/opacity/clip-path/mask so it was flattened per Step 4/6. All three
// paths shared the single literal fill `#3B45E6`, so Step 7's blind currentColor swap applies.
export function IconTrash16({ title, ...rest }: SvgIconProps) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M6.5 5.75C6.91421 5.75 7.25 6.08579 7.25 6.5V10.5C7.25 10.9142 6.91421 11.25 6.5 11.25C6.08579 11.25 5.75 10.9142 5.75 10.5V6.5C5.75 6.08579 6.08579 5.75 6.5 5.75Z"
        fill="currentColor"
      />
      <path
        d="M9.5 5.75C9.91421 5.75 10.25 6.08579 10.25 6.5V10.5C10.25 10.9142 9.91421 11.25 9.5 11.25C9.08579 11.25 8.75 10.9142 8.75 10.5V6.5C8.75 6.08579 9.08579 5.75 9.5 5.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 0.5C9.96413 0.5 10.4091 0.684507 10.7373 1.0127C11.0655 1.34088 11.25 1.78587 11.25 2.25V3H13.5C13.9142 3 14.25 3.33579 14.25 3.75C14.25 4.16421 13.9142 4.5 13.5 4.5H13.25V13C13.25 13.3315 13.1182 13.6494 12.8838 13.8838C12.6494 14.1182 12.3315 14.25 12 14.25H4C3.66848 14.25 3.35063 14.1182 3.11621 13.8838C2.88179 13.6494 2.75 13.3315 2.75 13V4.5H2.5C2.08579 4.5 1.75 4.16421 1.75 3.75C1.75 3.33579 2.08579 3 2.5 3H4.75V2.25C4.75 1.78587 4.93451 1.34088 5.2627 1.0127C5.59088 0.684507 6.03587 0.5 6.5 0.5H9.5ZM4.25 12.75H11.75V4.5H4.25V12.75ZM6.5 2C6.4337 2 6.37013 2.02636 6.32324 2.07324C6.27636 2.12013 6.25 2.1837 6.25 2.25V3H9.75V2.25C9.75 2.1837 9.72364 2.12013 9.67676 2.07324C9.62987 2.02636 9.5663 2 9.5 2H6.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
